import { makeVar } from '@apollo/client';
/**
 * This represents the current (save) state of the document.
 */
export const documentState = makeVar(undefined);
